module.exports = __webpack_public_path__ + "img/interaction-response-time.0da4d75f.png";